/** Human-readable labels for backend enum values. */

export const PROPERTY_STATUS_LABEL = {
    own: "Owns the property",
    recently_purchased: "Recently purchased",
    currently_purchasing: "Currently purchasing",
};

export const PROJECT_TYPE_LABEL = {
    rear_extension: "Rear extension",
    side_extension: "Side extension",
    loft: "Loft conversion",
    internal_reconfiguration: "Internal reconfiguration",
    combination: "Combination",
    other: "Other",
};

export const BUDGET_LABEL = {
    under_100k: "Under £100k",
    "100_150k": "£100k – £150k",
    "150_250k": "£150k – £250k",
    "250k_plus": "£250k+",
    guidance: "Needs guidance",
};

export const TIMING_LABEL = {
    asap: "ASAP",
    within_3m: "Within 3 months",
    "3_6m": "3 – 6 months",
    "6_12m": "6 – 12 months",
    more_than_12m: "More than 12 months",
};

export const STATUS_LIST = [
    "New", "Reviewing", "Feasible", "Contacted", "Consultation",
    "Design Started", "Design Completed", "Quotation", "Won", "Lost",
];

export const QUALITY_LIST = ["High", "Medium", "Low"];
export const SOURCE_LIST = ["Website", "Meta", "Manual"];
export const FEASIBILITY_LIST = ["pending_review", "feasible", "not_feasible"];
export const FEASIBILITY_LABEL = {
    pending_review: "Pending review",
    feasible: "Feasible",
    not_feasible: "Not feasible",
};

export const LOSS_REASON_LIST = [
    "Budget", "Location", "Scope", "Programme",
    "Planning / technical feasibility", "Unable to contact",
    "Chose another builder", "Project abandoned", "Other",
];
